// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1yC1T","detailsBorder":"styles_detailsBorder__3Alhx"};